import { render, staticRenderFns } from "./DraftBox.vue?vue&type=template&id=d0d8e6a2&scoped=true"
import script from "./DraftBox.vue?vue&type=script&lang=js"
export * from "./DraftBox.vue?vue&type=script&lang=js"
import style0 from "./DraftBox.vue?vue&type=style&index=0&id=d0d8e6a2&prod&lang=scss"
import style1 from "./DraftBox.vue?vue&type=style&index=1&id=d0d8e6a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d8e6a2",
  null
  
)

export default component.exports